const presets = [
  {
    key: 'content',
    regions: [
      {
        title: 'Menu Link',
        type: 'menu_link',
        content: [],
      },
      {
        title: 'Text Region 1',
        type: 'text',
        content: [
          {
            text: null,
          },
        ],
      },
    ],
  },
  {
    key: 'menu',
    regions: [
      {
        title: 'Menu Link',
        type: 'menu_link',
        content: [],
      },
      {
        title: 'Menu Region',
        type: 'menu',
        content: {},
      },
    ],
  },
  {
    key: 'video',
    regions: [
      {
        title: 'Menu Link',
        type: 'menu_link',
        content: [],
      },
      {
        content: {
          service_link: {
            type: 'video',
            target: null,
          },
        },
        title: 'Service Link Region 1 [video]',
        type: 'service_link',
      },
    ],
  },
  {
    key: 'service',
    regions: [
      {
        title: 'Menu Link',
        type: 'menu_link',
        content: [],
      },
      {
        content: {
          service_link: {
            type: 'service',
            target: null,
          },
        },
        title: 'Service Link Region 1 [service]',
        type: 'service_link',
      },
    ],
  },
];

export const DEFAULT_REGIONS = Object.freeze([
  {
    title: 'Menu Link',
    type: 'menu_link',
    content: [],
  },
  {
    title: 'Text Region 1',
    type: 'text',
    content: [
      {
        text: null,
      },
    ],
  },
  {
    content: [
      {
        aspect_ratio: '53:27',
        display_uri: null,
        image: null,
      },
      {
        aspect_ratio: '19:20',
        display_uri: null,
        image: null,
      },
    ],
    title: 'Image Region 1',
    type: 'image',
  },
  {
    content: [{
      target: null,
      x: 1165,
      y: 605
    }],
    title: 'QR Code region',
    type: 'qr',
  }
]);

export const findRegionPreset = (presetName) => {
  const regions = presets.find((p) => p.key === presetName.replace('service_link.', ''))?.regions || [];

  return regions;
};
